module.exports = __webpack_public_path__ + "img/玉竹.e8d8b0e0.jpg";